import { createLazyFileRoute } from "@tanstack/react-router";

import { NewResultPage } from "@/features/admin/routes/ResultNew";

export const Route = createLazyFileRoute("/_auth/admin/results/new")({
  component: NewResultPage,
});
